import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Banner from "../components/Banner";
import Section1 from "../components/sustainability/Section1";
import Section2 from "../components/sustainability/Section2";
import Section3 from "../components/sustainability/Section3";
import Section4 from "../components/sustainability/Section4";
import Section5 from "../components/sustainability/Section5";
import Section6 from "../components/sustainability/Section6";
import Section7 from "../components/sustainability/Section7";
import Section8 from "../components/sustainability/Section8";
import {
    containerVariants,
    itemVariants,
    photoVariants,
} from "../variants/variants";


const SustainabilityPage = () => {
    const { t } = useTranslation();
    
    const bannerData = {
        title: t("sustainability.title"),
        img: "/images/sustainability/sus.jpg",
    };



    return (
        <div>
            <div className="grid grid-cols-10">
                <div className="col-start-2 col-span-8 ">
                    <Banner bannerData={bannerData} />


                    <Section1 />


                    <motion.div 
                        className="bg-green-600 w-full grid grid-cols-1 md:grid-cols-2 mt-24 overflow-hidden"
                        initial="hidden"
                        whileInView="visible"
                        exit="exit"
                        variants={containerVariants}
                        
                    >
                        <motion.div
                            variants={itemVariants}
                            className="overflow-hidden"
                        >
                            <motion.img 
                                src="/images/sustainability/sustainability1.jpg" 
                                alt="Sürdürülebilirlik Raporu" 
                                className="h-96 w-full md:h-full object-cover"
                                variants={photoVariants}
                                initial="initial"
                                whileInView="whileInView"
                                exit="exit"
                          
                            />
                        </motion.div>
                        <motion.div 
                            className="p-5 py-16 md:p-16"
                            variants={itemVariants}
                        >
                            <motion.h2 
                                className="text-2xl lg:text-4xl font-bold text-white"
                                variants={itemVariants}
                            >
                                {t("sustainability.report.title")}
                            </motion.h2>

                            <motion.div 
                                className="mt-6"
                                variants={itemVariants}
                            >
                                <motion.p 
                                    className="text-20 text-white/90 mb-8 leading-relaxed"
                                    variants={itemVariants}
                                >
                                    {t("sustainability.report.description")}
                                </motion.p>
                                
                                <motion.a 
                                    href="https://online.flippingbook.com/view/668661133/" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    variants={itemVariants}
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <button className="bg-white text-green-600 px-8 py-4 rounded-lg font-semibold text-20 hover:bg-gray-100 transition-all duration-300 flex sm:flex-row flex-col items-center gap-3 group">
                                        <svg className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                        </svg>
                                        {t("sustainability.report.button")}
                                    </button>
                                </motion.a>
                                
                        
                            </motion.div>
                        </motion.div>
                    </motion.div>


                    <Section2 />

                    <Section3 />





                </div>
            </div>

            <Section4 />

            <Section5 />
            <Section6/>
            <Section7/>
            <Section8/>

        </div>
    );
};

export default SustainabilityPage;
